import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/api';
import { SelectItem } from "primeng/components/common/selectitem";
import { AdsCouponsService } from '../../../services/business/ads-coupons.service';
import { CreateAdsCouponModel } from '../../../models/inModels/adsCoupon';
import { AdvertOrderService } from '../../../services/business/advert-order.service';
import { AdsPricingResponse } from '../../../models/inModels/Advert';

@Component({
  selector: 'app-create-ads-coupon',
  templateUrl: './create-ads-coupon.component.html'
})

export class CreateAdsCouponComponent  {
	model: CreateAdsCouponModel;
	loading = false;
	error: Message[];
	messages: Message[];
	spaces: SelectItem[] = [];
	selectedSpace: SelectItem;
	durations: SelectItem[] = [];
	selectedDuration: SelectItem;
  	adPricingDropDown: AdsPricingResponse[] = [];
	constructor(
		private router: Router,
    private advertOrderService: AdvertOrderService,
		private service: AdsCouponsService,) {
		this.model = new CreateAdsCouponModel();
	}

  initDropDown(event) {
    this.advertOrderService.loadPricing().then(
			pricings => {
				this.adPricingDropDown = pricings;
        this.spaces = this.adPricingDropDown.map(x => {
          return {value: x.Id, label: x.Name};
				}
		)},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
		});
	}

	initDurationDropDown(event) {
		const durations: SelectItem[] = [];
		for (let i = 7; i <= 49; i += 7) {
			durations.push({value: i, label: `${i / 7} week${i > 7 ? 's': ''}`});
		}
		this.durations = durations;
	}

	setDuration() {
		this.model.DurationInDaysLimit = this.selectedDuration.value;
	}

  	setSpace(): void {
		this.model.AdSpace = this.selectedSpace.value;
	}


	goBack(): void {
		this.router.navigate(['/ads-coupons']);
	}

	save() {
		this.loading = true;
		this.model.Amount = Math.round(this.model.Amount);
		this.model.PercentageDiscount = Math.round(this.model.PercentageDiscount);
		this.service.create(this.model).then(
			result => {
				console.log("The generated coupon ", result);
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/ads-coupons/create-ads-coupon/create-ads-coupon.component.ts